module.exports = __webpack_public_path__ + "static/Haniff Alkaff-5a6c1050f956d8a329f0be2d8713d1a8.jpg";